import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import httpService  from '../../api/httpService';

function User() {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

// <----- fetching details for user page ----->   
    const fetchData = async (endpoint = '/User', searchParams = {}, pageNumber = 1) => {
        setLoading(true);
        try{
            const result = await httpService.getData(endpoint, {
                pageNumber: pageNumber,
                pageSize: 10,
                ...searchParams
            }, true);
            setData(result);
            setCurrentPage(result.retObject.currentPage);
            setTotalPages(result.retObject.totalPages);
        }catch(err){
            console.log(err.message);
            setError(err.message);
        }finally {
            setLoading(false);
        }
    };

    useEffect(() =>{
        fetchData();
    },[]);

// <------- Logic for pagination ------->  
    const handleNext = () => {
        if (currentPage < totalPages) {
            fetchData("/User", {}, currentPage + 1);
        }
    };

    const handleFirst = () => {
        if (currentPage > 1) {
            fetchData("/User", {}, 1);
        }
    };

    const handleLast = () => {
        if (currentPage < totalPages) {
            fetchData("/User", {}, totalPages);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            fetchData("/User", {}, currentPage - 1);
        }
    };


  return (
    <div className="app-content p-4">
        <div className="container-fluid mt-4">
            <div className="card custom-card card-min-height">
                <div className="card-header justify-content-between align-items-center">
                    <div className="card-title">User</div>
                    <div className='custom_btns'>
                        <li>
                            <Link to="/add-user" type="button" className="btn btn-outline-secondary btn-sm btn-wave">
                                <i className="fas fa-plus fa-sm side-menu__icon me-1 align-middle d-inline-block"></i>Add New User
                            </Link>
                        </li>
                        {/* <div className="search-bar">
                            <i className="fas fa-sm fa-search search-icon me-2"></i>
                            <input type="text" className="form-control serach-input-field" placeholder="Search..." />
                            <i className="fas fa-sliders-h fa-sm filter-icon me-2"></i>
                        </div> */}
                    </div>
                </div>
                <div className="card-body">
                    {loading ? (
                        <div className="d-flex justify-content-center align-items-center loader-container">
                            <button className="btn btn-outline-secondary mt-3" type="button">
                                <span className="spinner-border spinner-border-sm align-middle me-2" role="status"
                                    aria-hidden="true"></span>
                                Loading...
                            </button>
                        </div>
                    ):( 
                        <>
                            <div className='row pagination'>
                                <div className='col-md-12 text-end mb-3'>                                              
                                    <span> Page {currentPage} of {totalPages} </span>                                              
                                    <span className='btn btn-icon btn-sm bg-pagi-transparent'
                                        onClick={handleFirst} 
                                        disabled={currentPage === totalPages}
                                    >
                                            <i className="fas fa-angles-left"></i>
                                    </span>
                                    <span className='btn btn-icon btn-sm bg-pagi-transparent'
                                        onClick={handlePrevious} 
                                        disabled={currentPage === 1}                                                   
                                    >
                                        <i className="fas fa-chevron-left"></i>
                                    </span>                                                
                                    <span className='btn btn-icon btn-sm bg-pagi-transparent'
                                        onClick={handleNext} 
                                        disabled={currentPage === totalPages}
                                        >
                                            <i className="fas fa-chevron-right"></i>
                                    </span>
                                    <span className='btn btn-icon btn-sm bg-pagi-transparent'
                                        onClick={handleLast} 
                                        disabled={currentPage === totalPages}
                                        >
                                            <i className="fas fa-angles-right"></i>
                                    </span>                                               
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table id="dataTable" className='table table-hover border table-bordered'>
                                    <thead>
                                        <tr>
                                            <th>First Name</th>
                                            <th>Last Name</th>
                                            <th>Login Id</th>
                                            <th>Registry Name</th>
                                            <th>Country</th>
                                            <th>Status</th>
                                            <th>ISAKOS Admin</th>
                                            <th>Added By</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.retObject.users.length > 0 ? (data.retObject.users.map((item, index) => (
                                            <tr key = {item.userid}>
                                                {/* <td>
                                                    <div className="d-flex align-items-center">
                                                        <span className="avatar avatar-sm me-2 mt-1 avatar-rounded">
                                                            <img src="" alt=""  className="img-fluid" />
                                                        </span>
                                                        {`${item.firstname || ""} ${item.middlename || ""} ${item.lastname || ""}`.trim()}
                                                    </div>
                                                </td> */}
                                                <td>{item.firstname}</td>
                                                <td>{item.lastname}</td>
                                                <td>{item.loginid}</td>
                                                <td>{item.organization?.orgname || item.organization?.orgName || item.organization?.name}</td>                  
                                                <td>{item.organization?.countryRef?.countryName}</td>
                                                <td>
                                                    <span className={`badge ${item.status === 1 ? 'bg-success' : 'bg-danger'}`}>
                                                        {item.status === 1 ? 'Active' : 'Inactive'}
                                                    </span>
                                                </td>
                                                <td>{item.admin ? 'Yes' : 'No'}</td>
                                                <td>{item.addedBy}</td> 
                                                <td>
                                                    <span className="action-icon btn-icon btn-sm btn-success-light me-3" onClick={() => navigate(`/edit-user/${item.userid}`)} >
                                                        <i className="fa-regular fa-pen-to-square"></i>
                                                    </span>
                                                    {/* <span className="action-icon btn-icon btn-sm btn-danger-light">
                                                        <i className="fa-regular fa-trash-can"></i>
                                                    </span> */}
                                                </td>                  
                                            </tr>
                                        ))):(
                                            <tr>
                                                <td colSpan="5" className="text-center">
                                                    No Data
                                                </td>
                                            </tr>
                                        )} 
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )} 
                </div>
                    
            </div>
        </div>
    </div>
  )
}

export default User;
